import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import styled from "styled-components";
import NFTNav from "../components/NavComponents/NFTNav";
import PerksList from "../components/desktop/PerksList";
import { io } from 'socket.io-client';
import { sendMessagePerk } from '../utils/backendUtils';



const Mobile = styled.div`
  display: none;
  @media only screen and (max-device-width: 480px) {
    display: flex;
    height: 96vh;
    flex-direction: column;
  }
`;

const Title = styled.div`
    font-style: normal;
    font-weight: bold;
    font-size: 36px;

    display: flex;
    align-items: center;

    color: #FFFFFF;

`;

const Price = styled.div`
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    display: flex;
    align-items: center;

    color: #FFFFFF;
`;

const Subtitle = styled.div`
    font-family: IBM Plex Mono;
    font-style: normal;
    font-weight: 600;
    font-size: 15.5866px;
    line-height: 120%;
    /* or 19px */
   
    letter-spacing: -0.03em;

    color: #FFFFFF;

    color: #fff;
   
`;


const ActionBoxTitle = styled.div`
   font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 115%;
    /* identical to box height, or 23px */

    display: flex;
    align-items: center;
    text-align: center;
    text-transform: uppercase;

    color: #FFFFFF;
`;

const ActionBoxSubtitle = styled.div`
    font-family: IBM Plex Mono;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 145%;
    /* or 20px */

    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;

    opacity: 0.4;
    margin-top: 15px;
    margin-bottom: 24px;
    max-width: 278px;
`;


const ActionBox = styled.div`
    background: rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    color: #FFFFFF;
    padding: 32px 40px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-bottom: 12px;
    max-width: 477px;
`;

const Desktop = styled.div`
  display: none;
  @media (min-device-width: 481px) {
    display: flex;
    flex-direction: column;
    height: 100vh;
    opacity: 0.8
    align-items: flex-end;
    padding-left: 50px;
  }
`;


const GradientButton = styled.div`
    background: linear-gradient(95.39deg, #001AFF 3.78%, #DB00FF 100%);
    border-radius: 12px;
    padding: 13px;
    width: 100%;
    color: #fff;
    display: flex;
    justify-content: center;
    margin-top: 31px;

`;


export default function ClaimPerksPage(props) {
    const [perks, setPerks] = useState([]);
    const [active, setActive] = useState(1);


    
    useEffect(() => {
        //TODO update on API call
        async function fetchMyAPI() {
            // setPerks([{name: 'Send Message', id: 1}, {name: 'Throw Flashbang', id: 6}, {name: 'somethingelse', id: 3}, {name: 'somethingelse', id: 4}, {name: 'somethingelse', id: 5}, {name: 'somethingelse', id: 7}]);
            setPerks([{name: 'Send Message', id: 1}, {name: 'Throw Flashbang', id: 7}]);
        }

       fetchMyAPI();
    }, []);
   

    const sendMessage = () => {
        sendMessagePerk('Hey Rayiei! Love your streams. Keep up the good work', 'sirfnorth', 123, 'message')
    }

    const sendFlash = async () => {
        console.log('flash that shit')
        await fetch('https://be.namasteapis.com/api/v1/flash-test')
    }
 
    return (
        <>              
        <Desktop style={{}}>
            <NFTNav		    
                userChainId={1}
                showTabs={false}
                ownedTab={false}
            />
            <Title style={{justifyContent: 'center', width: '100%', marginTop: 40}}>CLAIM YOUR NFT PERKS</Title>
            <div style={{display: 'flex', justifyContent: 'space-evenly', marginTop: 42, paddingLeft: 120}}>
                <div style={{display: 'flex', flex: 4, flexWrap: 'wrap'}}>
                    <PerksList isStatic={false} setActive={setActive} active={active} perksData={perks} />
                    {/* {perkCards} */}
                </div>
                <div style={{display: 'flex', flex: 6, marginTop: 8}}>
                    <ActionBox>
                        {active == 1 && <>
                            <ActionBoxTitle>Send Message on Stream</ActionBoxTitle>
                            <ActionBoxSubtitle>This message will appear on stream in around 2 minutes after send. You can also keep it until next stream.</ActionBoxSubtitle>
                            <textarea style={{border: '1px solid grey', width: '100%', height: 200, background: 'transparent', padding: 13}} placeholder="Enter the message"></textarea>
                            <GradientButton className="hover" onClick={() => sendMessage()}>SEND THE MESSAGE</GradientButton>
                        </>
                        }
                        {active == 2 && <>
                            <ActionBoxTitle>FLASHBANG on-STREAM EFFECT</ActionBoxTitle>
                            <ActionBoxSubtitle>Throw a grenade on stream & blind all viewers for 6 seconds</ActionBoxSubtitle>
                            <video 
                                src={'https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/video/Flash_Final.webm'}
                                autoPlay
                                loop
                                style={{
                                    width: 390, height: 220
                                }} />
                            <GradientButton className="hover" onClick={() => sendFlash()}>THROW A FLASHBANG ON STREAM</GradientButton>
                        </>
                        }
                    </ActionBox>
                </div>
            </div>
            
            <br></br>
        </Desktop>
        </>
    );
}

